<ng-container *ngrxLet="isOpen$ as isOpen">
  <section class="flex items-center gap-3">
    <button
      *ngIf="!isOpen"
      class="border border-gray-border py-1 rounded-md px-2"
      (click)="open()"
      data-qa="filter-small"
    >
      <span class="font-semibold">{{ 'elioTable.filter' | transloco }}</span> : {{ size$ | async }}
    </button>
    <elio-button *ngIf="isOpen" [label]="'button.validate' | transloco" (onclick)="close()" dataQA="validate-filter" />
    <ng-content select="elio-sort" />
  </section>

  <section
    *ngIf="isOpen"
    class="absolute top-[52px] left-0 border border-gray-border shadow-md shadow-[#1267B31A] rounded-md bg-white z-2 flex flex-col pt-1.5 px-3"
  >
    <elio-filters
      @vSlideInOut
      class="bg-white -mx-3 overflow-x-hidden overflow-y-auto max-h-[70vh]"
      [absolute]="false"
    />
  </section>

  <section *ngIf="isOpen" class="absolute top-[52px] left-0 right-0 bottom-0 z-1 flex flex-col" (click)="close()">
    <div class="bg-gray-dark opacity-50 flex-grow"></div>
  </section>
</ng-container>
